import React from 'react';
import { InvoiceStatus } from './enums/invoiceStatus';
import { ManagerStatus } from './enums/managerStatus';
import { ProjectStatus } from './enums/projectStatus';
import { TalentStatus } from './enums/talentStatus';
import {
  ADMINISTRATION,
  ADMINISTRATION_COMPANIES,
  ADMINISTRATION_COMPANIES_CREATE,
  ADMINISTRATION_COMPANIES_EDIT,
  ADMINISTRATION_MANAGERS,
  ADMINISTRATION_MANAGERS_CREATE,
  ADMINISTRATION_MANAGERS_EDIT,
  ADMINISTRATION_TALENT,
  ADMINISTRATION_TALENT_CREATE,
  ADMINISTRATION_TALENT_EDIT,
  BULK_UPLOAD,
  CREATE_INVOICES,
  CREATE_PAYMENT,
  CREATE_PROJECT,
  EDIT_PROJECT,
  INVOICES,
  PROFILE,
  PROJECTS,
  TALENT
} from './router/constants';
import { ReportStatus } from './enums/reportStatus';

export const statusColors = {
  [ProjectStatus.IN_PROGRESS]: 'rgba(124, 214, 48, 0.4)',
  [ProjectStatus.COMPLETED]: 'rgba(84, 106, 220, 0.4)',
  [ProjectStatus.DRAFT]: 'rgba(255, 149, 0, 0.4)',
  [ProjectStatus.DECLINED]: 'rgba(255, 45, 85, 0.4)',
  [ProjectStatus.PENDING]: 'rgba(255, 204, 0, 0.4)',
  [ProjectStatus.EXPIRED]: 'rgba(100, 92, 90, 0.4)',
  [InvoiceStatus.SUBMITTED]: 'rgba(255, 149, 0, 0.4)',
  [InvoiceStatus.APPROVED]: 'rgba(124, 214, 48, 0.4)',
  [InvoiceStatus.REJECTED]: 'rgba(255, 45, 85, 0.4)',
  [ManagerStatus.ACTIVE]: 'rgba(124, 214, 48, 0.4)',
  [ManagerStatus.INACTIVE]: 'rgba(255, 45, 85, 0.4)',
  [InvoiceStatus.NOT_YET_SUBMITTED]: 'rgba(255, 204, 0, 0.4)',
  [InvoiceStatus.PAID]: 'rgba(84, 106, 220, 0.4)',
  [TalentStatus.ONBOARDING]: 'rgba(255, 149, 0, 0.4)',
  [ReportStatus.PAID]: 'rgba(84, 106, 220, 0.4)',
  [ReportStatus.APPROVED]: 'rgba(124, 214, 48, 0.4)',
  [ReportStatus.IN_PROGRESS]: 'rgba(255, 204, 0, 0.4)',
  [ReportStatus.REJECTED]: 'rgba(255, 45, 85, 0.4)',
  [ReportStatus.NOT_YET_SUBMITTED]: 'rgba(100, 92, 90, 0.4)',
  [ReportStatus.IMPORTED]: 'rgb(65, 105, 225, 0.4)',
  [ReportStatus.PROCESSED]: 'rgba(84, 106, 220, 0.4)',
  [ReportStatus.RETRIEVED]: 'rgba(255, 149, 0, 0.4)'
};

export const breadcrumbNameMap: { [key: string]: string } = {
  [PROJECTS]: 'View Projects',
  [CREATE_PROJECT]: 'Create Project',
  [EDIT_PROJECT]: 'Edit Project',
  [BULK_UPLOAD]: 'Bulk Uploads',
  [CREATE_PAYMENT]: 'Create Payments',
  [INVOICES]: 'View Invoices',
  [CREATE_INVOICES]: 'Create Invoice',
  [TALENT]: 'View Talent',
  [PROFILE]: 'Profile',
  [ADMINISTRATION]: 'Administration',
  [ADMINISTRATION_MANAGERS]: 'View Managers',
  [ADMINISTRATION_COMPANIES]: 'View Companies',
  [ADMINISTRATION_MANAGERS_CREATE]: 'Create Manager',
  [ADMINISTRATION_MANAGERS_EDIT]: 'Edit Manager',
  [ADMINISTRATION_COMPANIES_CREATE]: 'Create Company',
  [ADMINISTRATION_COMPANIES_EDIT]: 'Edit Company',
  [ADMINISTRATION_TALENT]: 'View Talent',
  [ADMINISTRATION_TALENT_EDIT]: 'Edit Talent',
  [ADMINISTRATION_TALENT_CREATE]: 'Create Talent'
};

export const textEllipsis: React.CSSProperties = {
  maxWidth: '100%',
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 2,
  overflow: 'hidden',
  textOverflow: 'ellipsis'
};

export const typingTimeOut = 600;

export const dashBorder = {
  p: 3,
  borderRadius: '10px',
  border: '1px dashed #B3B3B3'
};
